module.exports = __webpack_public_path__ + "static/media/passcode.3159150e.png";